import { RetirementFundType } from "../constants/payroll";
import useCurrentResourceCentre from "./useCurrentResourceCentre";

const useRcUsesCitPfSSf = (): {
  rcUsesProvidentFund: boolean;
  rcUsesSocialSecurityFund: boolean;
} => {
  const rc = useCurrentResourceCentre();
  const rcUsesProvidentFund = Boolean(rc?.retirementFundType === RetirementFundType.PROVIDENT_FUND);
  const rcUsesSocialSecurityFund = Boolean(
    rc?.retirementFundType === RetirementFundType.SOCIAL_SECURITY_FUND
  );

  return {
    rcUsesSocialSecurityFund,
    rcUsesProvidentFund
  };
};

export default useRcUsesCitPfSSf;
